import { useSWRConfig } from 'swr';
import { deleteFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import { displayError } from '@/utils/error/errorHandler';

const useDeleteAvailability = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const deleteAvailability = async (availId: number) => {
    try {
      if (employeeId === undefined)
        throw new Error('employeeId is undefined. Check URL.');

      await deleteFetcher(`/employees/${employeeId}/availabilities/${availId}`);

      // revalidate (= automatically refetch attachments)
      await mutate(`/employees/${employeeId}/availabilities`);
    } catch (err) {
      displayError(err);
    }
  };

  return {
    deleteAvailability,
  };
};

export default useDeleteAvailability;
